<template>
  <div class="change-contact-info-wrapper">
    <div class="change-contact-info-container">
      <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
      <div class="back-block" @click="$router.push({ name: 'settings' })">
        <img
          src="../../../public/custom/images/back-arrow.svg"
          class="back-img"
          alt="Back arrow"
        />
        <span class="back-btn-text">{{ $t('message.loanPage.back') }}</span>
      </div>
      <div class="info-section">
        <div class="section-title">{{ $t('message.changeContactInfoPage.contactsTitle') }}</div>

        <div class="form-grid contacts-grid">
          <div class="field-container disabled-field-container">
            <base-text-input
              :default-value="phone"
              :label="$t('message.changeContactInfoPage.fields.phone')"
              :name="'phone'"
              :disabled="true"
              :is-has-error-block="false"
              v-model="phone"
            />
          </div>

          <div class="field-container email-field-container">
            <base-text-input
              ref="emailInput"
              :default-value="email"
              :label="$t('message.changeContactInfoPage.fields.email')"
              :name="'email'"
              :validate-rules="'required'"
              v-model="email"
            />

            <div class="email-btn-container">
              <base-button
                :text="emailBtnText"
                :disabled="isConfirmBtnDisabled"
                :is-loading="isEmailBtnLoading"
                @click="sendEmailConfirmation()"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title">{{ $t('message.changeContactInfoPage.addressTitle') }}</div>

        <div class="form-grid address-grid">
          <div class="field-container">
            <base-select
              :label="$t('message.changeContactInfoPage.fields.country')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.country')"
              :default-value="address.living_address.country"
              :options-list="CONSTANTS.COUNTRY_TYPE_LIST"
              :dictionary-path="'message.signUp.livingAddressBlock.country.countryList.'"
              :name="'country'"
              v-model="address.living_address.country"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.postal_code"
              :label="$t('message.changeContactInfoPage.fields.postalCode')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.postalCode')"
              :name="'postal_code'"
              :is-has-error-block="false"
              v-model="address.living_address.postal_code"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.region"
              :label="$t('message.changeContactInfoPage.fields.region')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.region')"
              :name="'region'"
              :is-has-error-block="false"
              v-model="address.living_address.region"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.locality_type"
              :label="$t('message.changeContactInfoPage.fields.localityType')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.localityType')"
              :name="'locality_type'"
              :is-has-error-block="false"
              v-model="address.living_address.locality_type"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.locality_name"
              :label="$t('message.changeContactInfoPage.fields.locality')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.locality')"
              :name="'locality_name'"
              :is-has-error-block="false"
              v-model="address.living_address.locality_name"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.street_type"
              :label="$t('message.changeContactInfoPage.fields.streetType')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.streetType')"
              :name="'street_type'"
              :is-has-error-block="false"
              v-model="address.living_address.street_type"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.street_name"
              :label="$t('message.changeContactInfoPage.fields.street')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.street')"
              :name="'street_name'"
              :is-has-error-block="false"
              v-model="address.living_address.street_name"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.house_number"
              :label="$t('message.changeContactInfoPage.fields.house')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.house')"
              :name="'house_number'"
              :is-has-error-block="false"
              v-model="address.living_address.house_number"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.house_unit"
              :label="$t('message.changeContactInfoPage.fields.building')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.building')"
              :name="'house_unit'"
              :is-has-error-block="false"
              v-model="address.living_address.house_unit"
            />
          </div>

          <div class="field-container">
            <base-text-input
              :default-value="address.living_address.apartment_number"
              :label="$t('message.changeContactInfoPage.fields.apartment')"
              :placeholder="$t('message.changeContactInfoPage.placeholders.apartment')"
              :name="'apartment_number'"
              :is-has-error-block="false"
              v-model="address.living_address.apartment_number"
            />
          </div>
        </div>

        <div class="address-actions">
          <div class="footer-note">
            {{ $t('message.changeContactInfoPage.footerNote') }}
          </div>
          <div class="save-btn-container">
            <base-button
              :text="$t('message.changeContactInfoPage.buttons.save')"
              :min-height="'40px'"
              :disabled="isSaveAddressDisabled"
              :is-loading="isSaveAddressLoading"
              @click="saveLivingAddress()"
            />
          </div>
        </div>
      </div>
    </div>

    <base-modal v-if="isEmailModalVisible" @close="closeEmailModal()">
      <template v-slot:main>
        <div class="email-modal">
          <div class="email-modal-icon">!</div>
          <div class="email-modal-title">
            {{ $t('message.changeContactInfoPage.emailModal.title') }}
          </div>
          <div class="email-modal-text">
            {{ $t('message.changeContactInfoPage.emailModal.textStart') }}
            <span>{{ emailForConfirmation }}</span>
          </div>
          <div class="email-modal-otp-container">
            <base-text-input
              :default-value="emailOtp"
              :label="$t('message.changeContactInfoPage.emailModal.otpLabel')"
              :mask-pattern="'######'"
              :name="'emailOtp'"
              :validate-rules="'otp'"
              :max-length="6"
              v-model="emailOtp"
              :disabled="isEmailConfirmLoading"
            />
          </div>
          <div class="email-modal-btn-container">
            <base-button
              :text="$t('message.changeContactInfoPage.buttons.confirm')"
              :min-height="'48px'"
              :disabled="isEmailModalConfirmDisabled"
              :is-loading="isEmailConfirmLoading"
              @click="confirmEmail()"
            />
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseSelect from '../../components/base/BaseSelect.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import BaseModal from '../../components/base/BaseModal.vue';
import CONSTANTS from '../../constants/constants';

export default {
  name: 'ChangeContactInfo',
  inject: ['$httpService'],
  components: {
    BaseTextInput,
    BaseSelect,
    BaseButton,
    BaseModal
  },
  data() {
    return {
      CONSTANTS,
      phone: '',
      email: '',
      emailForConfirmation: '',
      emailOtp: '',
      keyWord: '',
      isEmailModalVisible: false,
      isEmailBtnLoading: false,
      isEmailConfirmLoading: false,
      isEmailChangeConfirmation: false,
      isSaveAddressLoading: false,
      address: {
        living_address: {
          country: '',
          region: '',
          district: '',
          locality_type: '',
          locality_name: '',
          street_type: '',
          street_name: '',
          house_number: '',
          house_unit: '',
          apartment_number: '',
          postal_code: ''
        },
        living_address_str: ''
      }
    };
  },
  async created() {
    await this.$store.dispatch('getProfile');

    this.setProfileData();
  },
  methods: {
    setProfileData() {
      this.phone = this.getFormattedPhone(this.profile?.contact?.phoneSMSVerification);
      this.email = this.profile?.email || '';
      this.keyWord = this.profile?.codeword || this.profile?.key_word || this.profile?.keyWord || '';
      this.address = this.getAddressData(this.profile?.living_address || this.profile?.address || {});
    },
    getFormattedPhone(phone) {
      if (!phone) return '';

      const digits = String(phone).replace(/\D/g, '');

      return `+${digits.slice(0, 3)} (${digits.slice(3, 5)}) ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
    },
    async sendEmailConfirmation() {
      this.isEmailBtnLoading = true;
      this.emailForConfirmation = this.email;
      this.emailOtp = '';
      this.isEmailChangeConfirmation = this.isEmailVerified;

      try {
        const response = await this.$httpService.auth.changeEmail(this.emailForConfirmation);

        if (!response) {
          throw new Error('Email send failed');
        }

        this.isEmailModalVisible = true;
      } catch (error) {
        this.$toast.error(this.$t('message.changeContactInfoPage.emailSendError'));
      } finally {
        this.isEmailBtnLoading = false;
      }
    },
    async confirmEmail() {
      this.isEmailConfirmLoading = true;

      try {
        const response = await this.$httpService.auth.confirmEmail({
          email: this.emailForConfirmation,
          otp: this.emailOtp
        });

        if (!response) {
          throw new Error('Email confirm failed');
        }

        this.closeEmailModal();
        this.$toast.success(this.emailSuccessToastText);
      } catch (error) {
        this.closeEmailModal();
        throw error;
      } finally {
        this.isEmailConfirmLoading = false;
      }
    },
    closeEmailModal() {
      this.isEmailModalVisible = false;
      this.emailOtp = '';
      this.isEmailConfirmLoading = false;
    },
    async saveLivingAddress() {
      if (this.isSaveAddressDisabled || this.isSaveAddressLoading) {
        return;
      }

      this.isSaveAddressLoading = true;

      try {
        const response = await this.$httpService.auth.changeLivingAddress(this.address);

        if (!response) {
          throw new Error('Living address save failed');
        }

        this.$toast.success(this.$t('message.changeContactInfoPage.addressSaveSuccess'));
        await this.$store.dispatch('getProfile');
        this.setProfileData();
      } catch (error) {
        this.$toast.error(this.$t('message.changeContactInfoPage.addressSaveError'));
      } finally {
        this.isSaveAddressLoading = false;
      }
    },
    getCountryCode(address) {
      const countryValue = address.country;
      const code = String(
        (countryValue && typeof countryValue === 'object'
          ? countryValue.code
          : countryValue) || address.country_id || ''
      );

      return CONSTANTS.COUNTRY_TYPE_LIST.includes(code) ? code : '';
    },
    getAddressData(address) {
      return {
        living_address: {
          country: this.getCountryCode(address),
          region: address.region || address.area || address.province || '',
          district: '',
          locality_type: address.locality_type || address.localityType || '',
          locality_name: address.locality_name || address.locality || address.localityName || '',
          street_type: address.street_type || address.streetType || '',
          street_name: address.street_name || address.street || address.streetName || '',
          house_number: address.house_number || address.house || '',
          house_unit: address.house_unit || address.building || '',
          apartment_number: address.apartment_number || address.apartment || address.flat || '',
          postal_code: address.postal_code || address.postalCode || ''
        },
        living_address_str: ''
      };
    }
  },
  computed: {
    ...mapGetters(['profile']),
    isEmailVerified() {
      return this.profile?.contact?.emailVerified;
    },
    emailBtnText() {
      return this.isEmailVerified
        ? this.$t('message.changeContactInfoPage.buttons.edit')
        : this.$t('message.changeContactInfoPage.buttons.confirm');
    },
    isConfirmBtnDisabled() {
      return !this.email;
    },
    isSaveAddressDisabled() {
      if (this.isSaveAddressLoading) {
        return true;
      }

      const requiredFields = [
        this.address.living_address.country,
        this.address.living_address.locality_type,
        this.address.living_address.locality_name,
        this.address.living_address.street_type,
        this.address.living_address.street_name,
        this.address.living_address.house_number
      ];

      return requiredFields.some((value) => !String(value || '').trim());
    },
    isEmailModalConfirmDisabled() {
      return !this.emailOtp || this.errors.has('emailOtp') || this.isEmailConfirmLoading;
    },
    emailSuccessToastText() {
      return this.isEmailChangeConfirmation
        ? this.$t('message.changeContactInfoPage.emailChangeSuccess')
        : this.$t('message.changeContactInfoPage.emailConfirmSuccess');
    }
  }
};
</script>

<style lang="scss" scoped>
  .change-contact-info-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .change-contact-info-container {
    width: 95%;
    min-height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .info-section {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: #FFFFFF;
    border: 1px solid #ECEDEE;
    box-shadow: 0 2px 8px rgba(1, 39, 59, 0.06);
  }

  .back-block {
    width: fit-content;
    height: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .back-img {
    margin-right: 4px;
    height: 18px;
    width: 18px;
  }

  .back-btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #878787;
  }

  .section-title {
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #01273B;
  }

  .form-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px 12px;
  }

  .field-container {
    min-width: 0;
  }

  .email-field-container {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 114px;
    gap: 8px;
    align-items: start;
  }

  .email-btn-container {
    height: 40px;
    margin-top: 30px;
    width: 136px;
  }

  .address-actions {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #ECEDEE;
  }

  .footer-note {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #7A7A7A;
  }

  .save-btn-container {
    width: 231px;
    height: 48px;
  }

  .field-container ::v-deep .input-label {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #7A7A7A;
  }

  .field-container ::v-deep .input-block,
  .field-container ::v-deep .select-block {
    height: 40px;
    min-height: 40px;
    border-radius: 6px;
    background-color: #FFFFFF;
  }

  .field-container ::v-deep .input {
    height: 38px;
    min-height: 38px;
    padding: 8px;
    font-size: 14px;
    line-height: 24px;
    color: #01273B;
    background-color: #FFFFFF;
  }

  .field-container ::v-deep .select-block .input {
    height: 100%;
    min-height: 100%;
  }

  .field-container ::v-deep .input:disabled {
    background-color: #FFFFFF;
    color: #A7A7A7;
  }

  .disabled-field-container ::v-deep .input-block {
    border-color: #ECEDEE;
    background-color: #FFFFFF;
  }

  .field-container ::v-deep .error-block {
    height: 16px;
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
  }

  .email-btn-container ::v-deep .button {
    min-height: 40px;
    max-height: 40px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 24px;
  }

  .email-modal {
    width: 480px;
    max-width: calc(95vw - 30px);
    min-height: 414px;
    padding: 17px 5px 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .email-modal-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #F2A500;
    font-weight: 700;
    font-size: 52px;
    line-height: 52px;
    color: white;
  }

  .email-modal-title {
    margin-bottom: 18px;
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.1px;
    color: #022131;
  }

  .email-modal-text {
    width: 440px;
    max-width: 100%;
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 24px;
    color: #101010;
  }

  .email-modal-text span {
    font-weight: 600;
  }

  .email-modal-otp-container {
    width: 440px;
    max-width: 100%;
    margin-bottom: 40px;
    text-align: left;
  }

  .email-modal-otp-container ::v-deep .input-label {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #7A7A7A;
  }

  .email-modal-otp-container ::v-deep .input-block {
    height: 48px;
    min-height: 48px;
    border-radius: 6px;
  }

  .email-modal-otp-container ::v-deep .input {
    height: 46px;
    min-height: 46px;
    padding: 8px;
    font-size: 14px;
    line-height: 24px;
    color: #01273B;
  }

  .email-modal-otp-container ::v-deep .error-block {
    height: 16px;
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
  }

  .email-modal-btn-container {
    width: 440px;
    max-width: 100%;
    height: 48px;
  }

  .route-name {
    @include route-name;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 1155px) {
    .change-contact-info-wrapper {
      padding-top: 40px;
    }

    .change-contact-info-container {
      @include base-page-container;

      align-items: flex-start;
      padding-top: 0;
    }

  }

  @media screen and (max-width: 900px) {
    .form-grid {
      grid-template-columns: 1fr;
    }

    .email-field-container {
      grid-template-columns: 1fr;
    }

    .email-btn-container {
      width: 180px;
      margin-top: 0;
    }

    .save-btn-container {
      width: 100%;
    }

    .email-modal {
      min-height: 360px;
    }

    .email-modal-text {
      margin-bottom: 24px;
    }

    .email-modal-otp-container {
      margin-bottom: 32px;
    }
  }
</style>
